import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useNewsNotifications } from '../hooks/use-news-notifications';

import { NotificationList } from './notification-list';

interface NotificationCenterDialogProps {
  open: boolean;
  onClose: () => void;
}

export const NotificationCenterDialog = ({ open, onClose }: NotificationCenterDialogProps) => {
  const { t } = useTranslation();
  const { bellNotifications } = useNewsNotifications();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6">{t('notifications.center.title')}</Typography>
        <IconButton size="small" onClick={onClose} aria-label={t('common.close')}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <NotificationList notifications={bellNotifications} />
      </DialogContent>
    </Dialog>
  );
};
